import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
    name: 'stringFormat',
    standalone: true,
    pure: true,
})
export class StringFormatPipe implements PipeTransform {
    transform(value: string, format: 'kebab' | 'titleCase' | string): string {
        switch (format) {
            case 'kebab':
                return this.toKebabCase(value);
            case 'titleCase':
                return this.toTitleCase(value);
            default:
                return value;
        }
    }

    private toKebabCase(value: string): string {
        return value
            .trim()
            .replace(/([a-z])([A-Z])/g, '$1-$2')
            .replace(/[\s_]+/g, '-')
            .toLowerCase();
    }

    private toTitleCase(value: string): string {
        if (!value) {
            return '';
        }
        return value
            .trim()
            .replace(/_/g, ' ')
            .toLowerCase()
            .replace(/\b\w/g, (c) => c.toUpperCase());
    }
}
